<template>
  <div class="follow-us">
    <div class="follow-us__header">
      <div class="follow-us__header-text">
        Follow us
      </div>
      <div class="follow-us__header-social">
        <facebook-icon class="header-social__item transition--color-bg" />
        <instagram-icon class="header-social__item transition--color-bg" />
      </div>
    </div>
    <div class="follow-us__images">
      <a
        v-for="(image, link) in followUsImages"
        :key="link"
        class="follow-us__link"
        :href="link"
        target="_blank"
        rel="nofollow noopener">
        <img
          :src="`/storage/uploads${image}`"
          alt=""
          class="images__item">
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FacebookIcon from 'Components/Socials/Facebook.vue';
import InstagramIcon from 'Components/Socials/Instagram.vue';

export default {
  name: 'FollowUs',

  components: {
    FacebookIcon,
    InstagramIcon,
  },

  computed: {
    ...mapState('products', ['followUsImages']),
    ...mapState(['userDevice']),
  },

  mounted() {
    this.$store.dispatch('products/getFollowUsImages');
  },
};
</script>

<style lang="scss" scoped>
  .follow-us__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
  }

  .follow-us__header-social {
    display: flex;
  }

  .follow-us__header-text {
    font-weight: 500;
    font-size: 21px;
  }

  .header-social__item {
    --circle-bg-color: #{$color--basic-menu};
    --circle-size: 32px;
    --icon-size: 13px;

    &:not(:last-child) {
      margin-right: 11px;
    }

    &:hover {
      --circle-bg-color: #{$color--basic-blue};
    }
  }

  .follow-us__images {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 5px;
    grid-template-rows: repeat(2, max-content) repeat(100, 0);
  }

  .follow-us__link {
    overflow: hidden;
  }

  .follow-us__link:first-child {
    margin-bottom: 8px;
  }

  @media screen and (min-width: 600px) {
    .follow-us__images {
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      grid-template-rows: repeat(1, max-content) repeat(100, 0);
    }

    .follow-us__link:first-child {
      margin-bottom: 0;
    }
  }

  @media screen and #{$screen-more-or-1024} {
    .follow-us__header {
      justify-content: flex-start;
      margin-bottom: 23px;
    }

    .follow-us__header-text {
      font-size: $text-25px;
      line-height: 30px;
      margin-right: 16px;
    }

    .header-social__item {
      --circle-size: 40px;
      --icon-size: 16px;

      &:not(:last-child) {
        margin-right: 9px;
      }
    }

    .follow-us__images {
      display: grid;
      grid-column-gap: 10px;
    }
  }
</style>
